module.exports = __webpack_public_path__ + "1.5.0-unryo/img/kafka.07140ef8.svg";